<template>
  <div v-if="links.length > 1" class="list-paginator">
    <div class="list-paginator__items">
      <template v-for="(link, k) in links">
        <a
          v-if="currentOffset !== link.offset"
          :key="`${k}_${link.offset}`"
          href="#"
          class="list-paginator__item"
          @click.prevent="onLinkClick(link.offset)"
        >
          {{ link.label }}
        </a>

        <span
          v-else
          :key="`${k}_${link.offset}_2`"
          class="list-paginator__item _active"
        >
          {{ link.label }}
        </span>
      </template>
    </div>

    <div class="list-paginator__options">
      <span>Показывать на странице&nbsp;</span>

      <a
        v-for="value in itemsPerPageOptions"
        :key="value"
        href="#"
        class="list-paginator__limit"
        :class="{ _active: value === currentLimit }"
        @click.prevent="onOptionLimitClick(value)"
        v-text="value"
      ></a>

      <span>&nbsp;результатов</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    // Общее количество элементов в списке.
    itemsTotal: {
      type: Number,
      required: true
    },
    // Список выбора количества элементов списка на странице.
    itemsPerPageOptions: {
      type: Array,
      default: () => []
    },
    // Текст метки выбора количества элементов списка на странице.
    itemsPerPageLabel: {
      type: String,
      default: 'Элементов на странице:'
    },
    // Максимальное количество отображаемых ссылок на страницы,
    // не считая ссылок на первую и последнюю страницу.
    rangeSize: {
      type: Number,
      default: 5
    }
  },

  data() {
    return {
      currentLimit: 20,
      currentOffset: 0
    };
  },

  computed: {
    ...mapGetters({
      offset: 'searchOffset',
      itemsPerPage: 'searchLimit'
    }),

    links() {
      if (this.itemsTotal === 0) return [];

      const itemsPerPage = this.currentLimit;
      const totalPages = Math.ceil(this.itemsTotal / itemsPerPage);
      const curPage = Math.floor(this.currentOffset / itemsPerPage) + 1;
      const rangeAvg = Math.ceil(this.rangeSize / 2);
      const rangeMin = Math.max(1, curPage - rangeAvg + 1);
      const rangeMax = Math.min(
        curPage + this.rangeSize - rangeAvg,
        totalPages
      );
      const makeLink = (label, offset) => ({
        label,
        offset
      });

      let links = [];

      // Создается 1-я метка
      if (rangeMin > 1) {
        links.push(makeLink(1, 0));
      }
      if (rangeMin > 2) {
        links.push(
          makeLink(rangeMin < 4 ? 2 : '...', (rangeMin - 2) * itemsPerPage)
        );
      }
      for (let num = rangeMin; num <= rangeMax; num++) {
        links.push(makeLink(num, (num - 1) * itemsPerPage));
      }
      if (rangeMax + 1 < totalPages) {
        links.push(
          makeLink(
            rangeMax + 2 < totalPages ? '...' : rangeMax + 1,
            rangeMax * itemsPerPage
          )
        );
      }
      // Создается последняя метка
      if (rangeMax < totalPages) {
        links.push(makeLink(totalPages, (totalPages - 1) * itemsPerPage));
      }

      return links;
    }
  },

  created() {
    this.currentLimit = this.itemsPerPage;
    this.currentOffset = this.offset;
  },

  methods: {
    onLinkClick(offset) {
      this.currentOffset = offset;
      this.$emit('update', { offset: offset });

      // TODO: to separate function, test it
      const elements = document.getElementsByClassName('scrollable-pagination');
      if (elements.length) {
        elements[0].scrollTop = 0;
      }
    },
    onOptionLimitClick(limit) {
      this.currentLimit = limit;
      // Корректируем значение currentOffset, чтобы оно соответствовало
      // первому элементу списка на текущей странице.
      this.currentOffset =
        this.currentOffset - (this.currentOffset % this.currentLimit);

      this.$emit('update', {
        offset: this.currentOffset,
        limit: limit
      });
    }
  }
};
</script>

<style lang="css" src="./list-paginator.css" />
